/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: { error: { type: 'variant', values: [ true ] } },
  rules: [ { if: { error: true }, tokens: { outlineColor: '#e12339' } } ],
  tokens: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    outlineColor: 'rgba(0, 0, 0, 0)',
    outlineOffset: null,
    outlineWidth: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0
  }
}
export default theme
